/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from '../../constants/Colors';
import { FontWeight, Text } from '../Text';
import { Breakpoints } from "../../constants/Breakpoints";
import { mediaHelper } from "../../utils/src";
import Icon from 'components/Icon';
import globalStyles from "globalStyles";
const { menu } = globalStyles.components;

const Main = styled.div`
  width: 340px;
  min-height: 100%;
`;

const Topo = styled.div`
  width: 340px;
  background: #fff;
  height: 110px;
  display: flex;
  align-items: center;
`;

const Title = styled(Text)`
  font-size: 14px;
  padding-left: 55px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: ${FontWeight.Bold};
  color: ${Colors.GRAY[3]};
  margin-top: 25px;
  display: block;
`;

const List = styled.ul`
  width: 100%;
  min-height: 100px;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-top: 60px;
  a{
    text-decoration: none;
  }
`;

const Item = styled(Text)`
  color: ${Colors.GRAY[3]};
  padding-left: 15px;
  padding-top: 15px;
  margin: 10px 20px 0px 20px;
  display: block;
  
  p{
    margin: 0px;
    font-weight: ${FontWeight.Medium};
    font-size: 15px;
    line-height: auto;
  }

  span{
    font-weight: ${FontWeight.Bold};
    font-size: 14px;
    padding-top: 5px;
    text-transform: uppercase;
    line-height: 17px;
    display: inline-block;
  }

  i{
    margin-right: 20px;
    float: left;
    margin-top: 5px;
  }

`;

const ElipseIcon = styled(Icon)`
border-radius: 100%;
height: 40px;
width: 40px;
padding: 7px;
background:${Colors.SECONDARY};
`;

const Remember = styled.div`
  margin-left: 20px;

  p{
    font-size: 14px;
    display: block;
  }

  span{
    font-size: 14px;
    display: block;
  }
`;

const SubTitle = styled(Text)`
  font-size: 16px;
  margin-left: 35px;
  color: ${Colors.GREEN};
  font-weight: ${FontWeight.Bold};
  opacity: 0.6;
  letter-spacing: 2px;
`;

const Container = styled.div`
height: 100%;
display: flex ;
flex-direction: column;
justify-content: space-between;
 .open{
    right: 0px;
    transition: all 1.5s;
  }
`;

const Settings = styled.div`
  margin-top: 40px;
  margin-left: 20px;
  bottom: 30px;
  left: 0px;
  span{
    line-height: 30px;
    font-weight: ${FontWeight.Bold};
    padding-left: 35px;
    i{
      margin-top: 0px;
    }
  }

  @media screen and (min-width: ${Breakpoints.lg}) {
    margin-top: unset;
  }
`;

const SettingsSubTitle = styled(Text)`
 font-weight: ${FontWeight.SemiBold};
  color: ${menu.subtitle};
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.1em;
  margin-bottom: 20px;
  text-transform: uppercase;
`;

const SettingsList = styled.ul`
  width: 100%;
  min-height: 200px;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-top: 20px;
  margin-bottom: -10px;
  a{
    text-decoration: none;
  }

  .active span{
    color:${Colors.PURPLE};
    margin-left: 1px;
    border-left: 4px solid ${Colors.GREEN};
    background: #fff;
    border-radius: 4px;
    box-shadow: 7px 5px 16px 4px rgba(177, 175, 175, 0.19);
  }
`;

const SettingsItem = styled(Text)`
  color: ${Colors.GRAY[3]};
  font-weight: ${FontWeight.Bold};
  padding-left: 55px;
  line-height: 50px;
  height: 50px;
  display: block;
  cursor:pointer;
  i{
    color: ${Colors.PURPLE};
    font-size: 27px;
    margin-right: 20px;
    float: left;
    margin-top: 10px;
  }
`;

export const UserPhoto = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 52px;
  min-width: 52px;
  height: 52px;
  background: ${Colors.WHITE};
  box-shadow: 0px 8px 20px 3px rgba(171, 171, 171, 0.22);
  border-radius: 50px;
  align-items: center;
  justify-content: center;
  margin-left: 26px;
`;

export const IconCheckContainer = styled.div`
  width: 26px;
  position: absolute;
  top: 32px;
  left: 36px;
`;

export const NameContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 26px;
`;

export const Name = styled(Text)`
  font-size: 16px;
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};

  @media(max-width: ${Breakpoints.sm}){
    font-size: 12px;
  };
`;

export const Country = styled(Text)`
  font-size: 16px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};

  @media(max-width: ${Breakpoints.sm}){
    font-size: 12px;
  };
`;


export { Main, Topo, Title, List, Item, Remember, SubTitle, Container, Settings, SettingsSubTitle, SettingsItem, SettingsList, ElipseIcon };
